import ConfirmacionQuiz from "../../../components/test/Quiz/ConfirmacionQuiz";
import "./layout.css";

const ConfirmacionTalentosPage = () => {
  return (
    <div className="quiz-page">
      <ConfirmacionQuiz />
    </div>
  );
};

export default ConfirmacionTalentosPage;
